import React from "react";
import styled from "styled-components";

const NavWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;

  @media (min-width: 768px) {
    ${(props) => props.hideOnDesktop && "display: none;"}
  }
`;

const ArrowButton = styled.button`
  background: #5b9bd5;
  border: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  transition: opacity 0.2s;
  padding: 0;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

const LeftArrowIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 5l-7 7 7 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <line x1="7" y1="12" x2="20" y2="12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const RightArrowIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 5l7 7-7 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <line x1="4" y1="12" x2="17" y2="12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const DotsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  @media (min-width: 768px) {
    display: none;
  }
`;

const Dot = styled.button`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  background: ${(props) => (props.active ? "#5b9bd5" : "#ccc")};
  transition: background 0.2s;
`;

const CarouselNavigation = ({
  selectedSnap,
  slideCount,
  prevDisabled,
  nextDisabled,
  onPrev,
  onNext,
  onGoTo,
  hideOnDesktop,
}) => {
  return (
    <NavWrapper className="fdn-carousel-nav" hideOnDesktop={hideOnDesktop}>
      <ArrowButton
        className="fdn-carousel-arrow-left"
        onClick={onPrev}
        disabled={prevDisabled}
        aria-label="Previous"
      >
        <LeftArrowIcon />
      </ArrowButton>
      <DotsWrapper className="fdn-carousel-dots">
        {Array.from({ length: slideCount }, (_, i) => (
          <Dot
            key={i}
            className={
              i === selectedSnap
                ? "fdn-carousel-dot fdn-carousel-dot-active"
                : "fdn-carousel-dot"
            }
            active={i === selectedSnap}
            onClick={() => onGoTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </DotsWrapper>
      <ArrowButton
        className="fdn-carousel-arrow-right"
        onClick={onNext}
        disabled={nextDisabled}
        aria-label="Next"
      >
        <RightArrowIcon />
      </ArrowButton>
    </NavWrapper>
  );
};

export default CarouselNavigation;



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselNavigation.jsx